import React, { useState, useEffect } from 'react';
import { Card, Nav, Tab, Spinner } from 'react-bootstrap';
import { FaNewspaper, FaBullhorn, FaCalendarAlt, FaArrowRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import API from '../../../services/api';

const RecentUpdates = ({ studentId }) => {
  const navigate = useNavigate();
  const [news, setNews] = useState([]);
  const [announcements, setAnnouncements] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadUpdates();
  }, []);

  const loadUpdates = async () => {
    try {
      setLoading(true);
      // Use the working blog endpoint directly
      const blogResponse = await API.get('/public/blog?limit=10');
      console.log('Blog response:', blogResponse.data);
      
      const allPosts = blogResponse.data.data?.posts || [];
      
      // Filter posts by category (adjust category names as per your database)
      setNews(allPosts.filter(p => p.category === 'news' || p.category === 'News'));
      setAnnouncements(allPosts.filter(p => p.category === 'announcement' || p.category === 'Announcement'));
      setEvents(allPosts.filter(p => p.category === 'event' || p.category === 'Event'));
      
    } catch (error) {
      console.error('Failed to load updates:', error);
      setNews([]);
      setAnnouncements([]);
      setEvents([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return '';
    return new Date(date).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
    });
  };

  if (loading) {
    return (
      <Card className="recent-updates-card h-100">
        <Card.Body className="text-center py-5">
          <Spinner animation="border" variant="primary" size="sm" />
          <p className="mt-2 text-muted small">Loading updates...</p>
        </Card.Body>
      </Card>
    );
  }

  // Check if there's any content to show
  const hasContent = news.length > 0 || announcements.length > 0 || events.length > 0;

  if (!hasContent) {
    return (
      <Card className="recent-updates-card h-100">
        <Card.Body className="text-center py-5">
          <FaNewspaper size={40} className="text-muted mb-3 opacity-50" />
          <p className="text-muted">No updates available</p>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="recent-updates-card h-100">
      <Card.Body>
        <Tab.Container defaultActiveKey="news">
          <Nav variant="tabs" className="updates-tabs">
            {news.length > 0 && (
              <Nav.Item>
                <Nav.Link eventKey="news">
                  <FaNewspaper className="me-2" /> News ({news.length})
                </Nav.Link>
              </Nav.Item>
            )}
            {announcements.length > 0 && (
              <Nav.Item>
                <Nav.Link eventKey="announcements">
                  <FaBullhorn className="me-2" /> Announcements ({announcements.length})
                </Nav.Link>
              </Nav.Item>
            )}
            {events.length > 0 && (
              <Nav.Item>
                <Nav.Link eventKey="events">
                  <FaCalendarAlt className="me-2" /> Events ({events.length})
                </Nav.Link>
              </Nav.Item>
            )}
          </Nav>

          <Tab.Content className="mt-3">
            {news.length > 0 && (
              <Tab.Pane eventKey="news">
                {news.map(item => (
                  <div key={item.id} className="update-item" onClick={() => navigate(`/blog/${item.slug}`)}>
                    <div className="update-content">
                      <h6>{item.title}</h6>
                      <small className="text-muted">{formatDate(item.published_date || item.created_at)}</small>
                    </div>
                    <FaArrowRight className="update-arrow" />
                  </div>
                ))}
              </Tab.Pane>
            )}
            
            {announcements.length > 0 && (
              <Tab.Pane eventKey="announcements">
                {announcements.map(item => (
                  <div key={item.id} className="update-item" onClick={() => navigate(`/blog/${item.slug}`)}>
                    <div className="update-content">
                      <h6>{item.title}</h6>
                      <small className="text-muted">{formatDate(item.published_date || item.created_at)}</small>
                    </div>
                    <FaArrowRight className="update-arrow" />
                  </div>
                ))}
              </Tab.Pane>
            )}
            
            {events.length > 0 && (
              <Tab.Pane eventKey="events">
                {events.map(item => (
                  <div key={item.id} className="update-item" onClick={() => navigate(`/blog/${item.slug}`)}>
                    <div className="update-content">
                      <h6>{item.title}</h6>
                      <small className="text-muted">{formatDate(item.published_date || item.created_at)}</small>
                    </div>
                    <FaArrowRight className="update-arrow" />
                  </div>
                ))}
              </Tab.Pane>
            )}
          </Tab.Content>
        </Tab.Container>
      </Card.Body>
    </Card>
  );
};

export default RecentUpdates;